var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"scroll-down w-100 text-center",attrs:{"href":"javascript:void(0)"}},[_c('span',[_vm._v(_vm._s(_vm.$t("label.scrollDown")))]),_c('br'),_c('img',{attrs:{"src":`/img/scroll-down.svg`,"alt":"Scroll Down"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }